import Vue from 'vue';

// When the request succeeds
const success = () => {
};

// When the request fails
const failed = () => {
};

export default () => Vue.$http.post('/hide-top-bar-info')
    .then((response) => {
      if (response && response.status === 200) {
        success();
      }
    })
    .catch(() => {
      failed();
    });



// WEBPACK FOOTER //
// ./src/app/services/configuration/hideTopBarInfo.js